'use client';

import { useEffect, useRef } from 'react';

import { handlePromise } from '@onyx/utils/promises';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useSession } from 'next-auth/react';

import { useStore } from '../state/store-provider';
import { getCatalogAction } from './catalog-action';

export const CatalogInitializer = () => {
  const { status: sessionStatus } = useSession();
  const {
    hasCatalog,
    retryCount,
    catalogFetchSucceeded,
    catalogFetchFailed,
    setCatalogStatus,
  } = useStore((state) => ({
    hasCatalog: Boolean(state.catalog.catalog),
    retryCount: state.catalog.retryCount,
    catalogFetchSucceeded: state.catalog.catalogFetchSucceeded,
    catalogFetchFailed: state.catalog.catalogFetchFailed,
    setCatalogStatus: state.catalog.setCatalogStatus,
  }));
  const lastHandledRetryCount = useRef<number | undefined>(undefined);

  useEffect(() => {
    // Wait for the session to resolve before fetching. This avoids firing an
    // unauthenticated request during Teams' silent sign-in, and re-fires once
    // authenticated because the ref below is left untouched while waiting.
    if (sessionStatus !== 'authenticated') {
      return;
    }

    if (lastHandledRetryCount.current === retryCount) {
      return;
    }

    lastHandledRetryCount.current = retryCount;
    setCatalogStatus(hasCatalog ? 'refreshing' : 'loading');

    void (async () => {
      const [error, data] = await handlePromise(getCatalogAction());

      if (error || !data) {
        catalogFetchFailed();
        return;
      }

      catalogFetchSucceeded(data);
    })();
  }, [
    sessionStatus,
    hasCatalog,
    retryCount,
    catalogFetchSucceeded,
    catalogFetchFailed,
    setCatalogStatus,
  ]);

  return null;
};
